import React from 'react'
import { IProps as ISelect, Select } from 'marketing-site/src/library/elements/Select'
import {
  ISelect as IContentfulSelect,
  ISelectOption as IContentfulSelectOption,
} from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulSelect = (data: IContentfulSelect) => (
  <EntryMarker entry={data}>{() => <Select {...transformSelect(data)} />}</EntryMarker>
)

export function transformSelectOption({ fields }: IContentfulSelectOption) {
  return {
    ...fields,
    isSelected: false,
  }
}

export function transformSelect({ fields }: IContentfulSelect): ISelect {
  return {
    ...fields,
    options: fields.options.map(transformSelectOption),
  }
}
